import { action } from 'typesafe-actions';

import { IAgreementListFilterParams } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterParams';
import { IAgreementIndex } from 'APIPackage/AgreementListModule/interfaces/IAgreementIndex';

import { AgreementListActionsEnum } from '../enums/AgreementListActionsEnum';
import { IAgreementRaw } from '../interfaces/IAgreementRaw';

export const agreementListInitPage = () => action(AgreementListActionsEnum.AGREEMENT_LIST_INIT_PAGE);
export const agreementListSetSearchValue = (value: string) =>
  action(AgreementListActionsEnum.AGREEMENT_LIST_SET_SEARCH_VALUE, { value });
export const agreementListGetData = (searchValue = '') =>
  action(AgreementListActionsEnum.AGREEMENT_LIST_GET_DATA, { searchValue });
export const agreementListGetDataNextPage = () => action(AgreementListActionsEnum.AGREEMENT_LIST_GET_DATA_NEXT_PAGE);
export const agreementListSetData = (
  data: IAgreementRaw[],
  page: number,
  pageCount: number,
  totalCount: number,
  rejected: number,
) => action(AgreementListActionsEnum.AGREEMENT_LIST_SET_DATA, { data, page, pageCount, totalCount, rejected });
export const agreementListSetOrder = (order: string | null) =>
  action(AgreementListActionsEnum.AGREEMENT_LIST_SET_ORDER, { order });
export const agreementListFindKnm = (filterParam: IAgreementListFilterParams, size?: number) =>
  action(AgreementListActionsEnum.AGREEMENT_LIST_FIND_KNM, { filterParam, size });
export const agreementListSetFindData = (findData: IAgreementIndex[]) =>
  action(AgreementListActionsEnum.AGREEMENT_LIST_SET_FIND_DATA, { findData });
